export const ACTIONS_MINE_PLAN = {
  INVALIDATE: 'MINE_PLAN_INVALIDATE',
  RECEIVE: 'MINE_PLAN_RECEIVE',
  DELETE: 'MINE_PLAN_DELETE',
  UPDATE: 'MINE_PLAN_UPDATE',
};

const minePlanConstants = {};

export default minePlanConstants;
